import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import { TimelineStepStatus } from '@interfaces/models/timeline';
import Icon from '@components/atoms/icon/icon';
import { PropsWithChildren } from 'react';
import styles from '../../product-timeline.module.scss';

const Wrapper = ({ status, children }: { status: TimelineStepStatus } & PropsWithChildren) => {
  const customStyles: Partial<Record<TimelineStepStatus, string>> = {
    pending: styles.ordersSales__mainRight__steps__step__statusPill__orange,
    cancelled: styles.ordersSales__mainRight__steps__step__statusPill__red,
    ongoing: styles.ordersSales__mainRight__steps__step__statusPill__blue,
  };

  return (
    <div
      data-cy={`timeline-card-status-${status}`}
      className={clsx(
        styles['ordersSales__mainRight__steps__step__box--text--625'],
        styles.ordersSales__mainRight__steps__step__statusPill,
        customStyles[status],
      )}
    >
      {children}
    </div>
  );
};

const LabelView: React.FC<{
  status: TimelineStepStatus;
}> = ({ status }) => {
  const { t } = useTranslation('orders-sales');
  switch (status) {
    case 'ongoing':
      return (
        <Wrapper status={status}>
          <Icon
            className={styles.ordersSales__mainRight__steps__step__statusPill__blue__icon}
            name="clock-default"
            ariaHidden
          />
          {t('MY_ACCOUNT.ORDERS_SALES.PRODUCT.STATUS.IN_PROGRESS')}
        </Wrapper>
      );
    case 'cancelled':
      return (
        <Wrapper status={status}>
          <Icon
            className={styles.ordersSales__mainRight__steps__step__statusPill__red__icon}
            name="clear-default"
            ariaHidden
          />
          {t('MY_ACCOUNT.ORDERS_SALES.PRODUCT.STATUS.CANCELLED')}
        </Wrapper>
      );
    case 'pending':
      return (
        <Wrapper status={status}>
          <Icon
            className={styles.ordersSales__mainRight__steps__step__statusPill__orange__icon}
            name="clock-default"
            ariaHidden
          />
          {t('MY_ACCOUNT.ORDERS_SALES.PRODUCT.STATUS.PENDING')}
        </Wrapper>
      );
    case 'done':
    case 'upcoming':
    case 'none':
      return <></>;
  }
};

export default LabelView;
